const category = [
  {
    id: "158",
    title: "投资入门",
    children: [
      {
        id: 161,
        title: "开户",
      },
      {
        id: 162,
        title: "出入金",
      },
      {
        id: 163,
        title: "交易",
      },
      {
        id: 164,
        title: "名词解释",
      },
    ],
  },
  {
    id: "159",
    title: "投资进阶",
    children: [
      {
        id: 165,
        title: "交易指导",
      },
      {
        id: 166,
        title: "盈利计算",
      },
      {
        id: 167,
        title: "产品介绍",
      },
      {
        id: 172,
        title: "专家评论",
      },
    ],
  },
  {
    id: "160",
    title: "投资高手",
    children: [
      {
        id: 168,
        title: "技巧学习",
      },
      {
        id: 169,
        title: "专家观点",
      },
      {
        id: 170,
        title: "教学专题",
      },
      {
        id: 171,
        title: "推荐有奖",
      },
    ],
  },
  {
    id: "173",
    title: "技术指标",
    children: [
      {
        id: 174,
        title: "指标分析",
      },
    ],
  },
  {
    id: "226",
    title: "帮助中心",
    children: [
      {
        title: "虚拟币",
        id: 233,
      },
      {
        title: "账户相关",
        id: 234,
      },
      {
        title: "合约指南",
        id: 235,
      },
      {
        title: "充值提现",
        id: 236,
      },
      {
        title: "如何下载",
        id: 237,
      },
    ],
  },
  {
    id: "228",
    title: "公告",
    children: [
      {
        title: "官网公告",
        id: "228",
      },
    ],
  },
];

const limitNews = 5;
let linkConfig = {
  h5transaction: "",
  msite: "",
  mis: "https://mis.atbground.com",
  online: "https://antofx.kf5.com/kchat/1040026#/",
  download: {
    ios: "https://apps.apple.com/cn/app/id6473134887",
    android: {
      global: "https://downloads.allkadull.com/source/material/MJJY_GW.apk",
      tuijian: "https://downloads.allkadull.com/source/material/MJJY_tuijian.apk",
      sms: "https://downloads.allkadull.com/source/material/MJJY_SMS.apk",
      anto: [
        "https://downloads.allkadull.com/source/material/MJJY_GW.apk",
        "https://mp-18b59665-8ace-4294-a961-e5d5164f6bef.cdn.bspapp.com/GW/2025_6/MJJY_GW_v310.apk",
      ],
      anto_backup:
        "https://mp-18b59665-8ace-4294-a961-e5d5164f6bef.cdn.bspapp.com/GW/2025_6/MJJY_GW_v310.apk",
    },
  },
};
if (process.env.BUILD_ENV === "uat") {
  linkConfig.msite = "https://m.atbgovernor.com";
  linkConfig.mis = "https://mis.atbgovernor.com";
  linkConfig.h5transaction = "https://mtrade.atbgovernor.com/?utm_source=H5";
}

if (process.env.BUILD_ENV !== "uat") {
  const baseDomain = window.location.hostname.replace(/^[^.]+\./, '');
  linkConfig.h5transaction = `${window.location.protocol}//mtrade.${baseDomain}/?utm_source="H5"`;
}

export { limitNews, linkConfig, category };
